import getDeviceType from './DeviceTypeUtil';

/*
Clears the credit inline summary and scheduledPayment xAPI
This way when the user returns from Fusion, they make a fresh API call (they see the data reflected)
https://confluence5/display/CSTMGMT/xAPI+Invalidate+Inline+Cache+Tech+Design+Details
On the UI, we dont check the response, just make the xAPI call.
@return Promise object (resolves whether or not call was successful)
*/
const clearApiCache = (action = '') => new Promise((resolve) => {
  // Skip clearing of the cache for non-SSO actions (apply and activation)
  if (action !== 'activateCard' && action !== 'applyNow' && action !== 'verify' && action !== 'activation') {
    const BRAND_NAME = (process.env.ENTRY_POINT === 'bcom') ? 'bloomingdales' : 'macys';
    const deviceType = getDeviceType();

    const onlineUIDCookieName = `${BRAND_NAME}_online_uid`;
    const onlineUID = (document.cookie.match(new RegExp(`(?:^|;\\s*)${onlineUIDCookieName}=([^;]+)`)) || [])[1];
    const randomNumber = `${onlineUID + Math.floor(Date.now() / 1000)}`;
    const url = '/account-xapi/api/creditservice/invalidateinlinecache';

    const headers = {
      'x-macys-request-id': randomNumber,
      'x-macys-clientid': deviceType,
    };

    // make xAPI call to clear cache
    // dont care about response so we dont need
    // to do much inside the callback function
    fetch(url, {
      method: 'GET',
      headers,
    }).then(resolve)
      .catch(resolve);
  } else {
    resolve();
  }
});

/* eslint-disable */
export {
  clearApiCache,
};
/* eslint-enable */
